module.exports = __webpack_public_path__ + "img/av008.a77c6fc6.png";